import { Box, Typography } from '@mui/material';
import Loading from '../../Loading/Loading';

export const OverlayLoading = () => {
  return (
    <Box
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        borderRadius: '8px',
      }}
    >
      <Box style={{ textAlign: 'center' }}>
        <Loading />
        <Typography variant="body1" style={{ marginTop: '16px' }}>
          Updating...
        </Typography>
      </Box>
    </Box>
  );
};
